import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmInfo } from "../models/LlmInfo";

export const useCreateLlm = () => {
  const {
    data: isCreated,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const createLlm = async (llmData: Partial<LlmInfo>) => {
    await call("/admin/llm", "POST", undefined, llmData);
  };

  return {
    createLlm,
    isCreated,
    isLoading,
    isFailed,
  };
};
